import script from "./ReportsTextList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsTextList.vue?vue&type=script&setup=true&lang=js"

import "./ReportsTextList.vue?vue&type=style&index=0&id=747443be&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-747443be"]])

export default __exports__